import script from "./ReferenceThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceThumbnail.vue?vue&type=style&index=0&id=b8d872ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d872ba"]])

export default __exports__